import request from '@/utils/request'

export function getAdminList(params) {
  return request({
    url: '/admin/admin/list',
    method: 'get',
    params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/admin',
    method: 'post',
    data
  })
}

export function updateAdmin(data) {
  return request({
    url: '/admin/admin',
    method: 'put',
    data
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/admin/' + id,
    method: 'delete'
  })
}

export function resetAdminPassword(id) {
  return request({
    url: '/admin/admin/reset-password/' + id,
    method: 'put'
  })
}

export function getAdminDetail(id) {
  return request({
    url: '/admin/admin/' + id,
    method: 'get'
  })
}
